import api from 'store/services/api';

import { setPetitionNotFound } from './modal';

export const GETDAYS = 'request/GETDAYS';
export const GETHOURS = 'request/GETHOURS';
export const SETDATETIME = 'request/SETDATETIME';
export const GETREQUEST = 'request/GETREQUEST';
export const SETREQUEST = 'request/SETREQUEST';
export const EDITREQUEST = 'request/EDITREQUEST';
export const GETDATA_FROM_TOKEN = 'request/GETDATA_FROM_TOKEN';
export const RESET_TOKEN = 'request/RESET_TOKEN';
export const RESET_EMAIL_TOKEN = 'request/RESET_EMAIL_TOKEN';

const initialState = {
  actualRequest: undefined,
  dateTime: undefined,
  schudule: undefined,
  days: undefined,
  fullDays: undefined,
  dataByToken: undefined,
};

const request = (state = initialState, action) => {
  switch (action.type) {
    case GETDAYS:
      return {
        ...state,
        days: action.playload.availableDays,
        fullDays: action.playload.fullDays,
      };
    case GETHOURS:
      return {
        ...state,
        schudule: action.playload,
      };
    case SETDATETIME:
      return {
        ...state,
        dateTime: action.playload,
      };
    case GETREQUEST:
      return {
        ...state,
        dateTime: undefined,
        schudule: undefined,
        actualRequest: action.playload,
      };
    case SETREQUEST:
      return {
        ...state,
        dateTime: undefined,
        schudule: undefined,
        actualRequest: action.playload,
      };
    case EDITREQUEST:
      return {
        ...state,
        dateTime: undefined,
        schudule: undefined,
        actualRequest: action.playload,
      };
    case GETDATA_FROM_TOKEN:
      return {
        ...state,
        dataByToken: action.playload,
      };
    case RESET_TOKEN:
      return {
        ...state,
        dataByToken: undefined,
      };
    case RESET_EMAIL_TOKEN:
      return {
        ...state,
        dataRefreshToken: action.playload,
      };
    default:
      return state;
  }
};

export default request;

export const getDays = (
  building = undefined,
  start_date = undefined,
  end_date = undefined,
) => {
  return dispatch => {
    Promise.all([
      api.get(dispatch, 'available-days-with-hours', building, {
        start_date,
        end_date,
      }),
    ]).then(([availableDays]) => {
      dispatch({
        type: GETDAYS,
        playload: {
          availableDays,
          fullDays: [''],
        },
      });
    });
  };
};

export const getHours = (building = undefined, day = undefined) => {
  return dispatch => {
    if (day)
      api.get(dispatch, 'available-hours', building, { date: day }).then(r => {
        dispatch({
          type: GETHOURS,
          playload: { day, hours: r },
        });
        dispatch({
          type: SETDATETIME,
          playload: undefined,
        });
      });
    else {
      dispatch({
        type: GETHOURS,
        playload: undefined,
      });
      dispatch({
        type: SETDATETIME,
        playload: undefined,
      });
    }
  };
};

export const setDateTime = (dateTime = undefined) => {
  const playload = dateTime;
  return dispatch => {
    dispatch({
      type: SETDATETIME,
      playload,
    });
  };
};

export const setRequest = (request = undefined) => {
  return dispatch => {
    if (request !== undefined) {
      api.post(dispatch, 'petitions', request).then(r => {
        dispatch({
          type: SETREQUEST,
          playload: r,
        });
      });
    } else {
      dispatch({
        type: SETREQUEST,
        playload: initialState.actualRequest,
      });
    }
  };
};

export const getRequest = (ref, token) => {
  return dispatch => {
    if (ref && token) {
      api
        .get(dispatch, `petitions/public/${ref}?token=${token}`)
        .then(r => {
          dispatch({
            type: GETREQUEST,
            playload: r,
          });
        })
        .catch(error => {
          console.error('Error getRequest', error);
          setPetitionNotFound(dispatch);
          dispatch({
            type: GETREQUEST,
            playload: null,
          });
        });
    } else {
      dispatch({
        type: GETREQUEST,
        playload: null,
      });
    }
  };
};

export const editRequest = (ref, token, request) => {
  return dispatch => {
    if (ref && token && request) {
      return api
        .post(dispatch, `petitions/public/${ref}?token=${token}`, request)
        .then(r => {
          dispatch({
            type: EDITREQUEST,
            playload: r,
          });
        })
        .catch(error => {
          console.error('Error editRequest', error);
        });
    } else {
      dispatch({
        type: EDITREQUEST,
        playload: null,
      });
    }
  };
};

export const resetEmailToken = (ref, token) => {
  return dispatch => {
    if (ref && token) {
      return api
        .get(dispatch, `petitions/public/${ref}/email?token=${token}`)
        .then(r => {
          dispatch({
            type: RESET_EMAIL_TOKEN,
            playload: r,
          });
        })
        .catch(error => {
          console.error('Error resetEmailToken', error);
        });
    } else {
      dispatch({
        type: RESET_EMAIL_TOKEN,
        playload: null,
      });
    }
  };
};

export const cancelRequest = (id, email) => {
  return dispatch => {
    api.delete(dispatch, 'petitions/' + id + '/' + email).then(r => {
      if (typeof r.status === 'number') {
        if (r.status === 404) {
          setPetitionNotFound(dispatch);
        } else {
          console.log('error', r.status, r.statusText);
        }
      } else {
        dispatch({
          type: SETREQUEST,
          playload: r,
        });
      }
    });
  };
};

export const getDataFromToken = token => {
  return dispatch => {
    api
      .get(dispatch, 'petition', undefined, { token }) // TODO: endpoint fake
      .then(res => {
        if (typeof res.status === 'number') {
          if (res.status === 404) {
            setPetitionNotFound(dispatch);
          } else {
            console.log('Error getDataFromToken', res.status, res.statusText);
          }
        } else {
          dispatch({
            type: GETDATA_FROM_TOKEN,
            playload: res,
          });
        }
      })
      .catch(error => {
        console.log('Error getDataFromToken', error);
      });
  };
};

export const resetToken = (id, email) => {
  return dispatch => {
    api.post(dispatch, 'petitions/' + id + '/' + email).then(res => {
      if (typeof res.status === 'number') {
        if (res.status === 404) {
          setPetitionNotFound(dispatch);
        } else {
          console.log('error', res.status, res.statusText);
        }
      } else {
        dispatch({
          type: RESET_TOKEN,
          playload: res,
        });
      }
    });
  };
};
